import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";

export default function FilteredCreateSelector({
  admin,
  filteredData,
  setFilteredData,
}) {
  const createdBy = filteredData.createdByIds || [];

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const selectedIds = value.map(
      (selectedValue) => admin.find((person) => person.id === selectedValue).id
    );

    setFilteredData((prevData) => ({
      ...prevData,
      createdByIds: selectedIds,
    }));
  };

  return (
    <div style={{ margin: "1em" }}>
      <Typography variant="h6" sx={{ fontSize: "14px", mb: 1 }}>
        Created By
      </Typography>

      <FormControl sx={{ width: "100%" }}>
        <InputLabel id="demo-multiple-checkbox-label">Created By</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={createdBy.map(
            (selectedId) => admin.find((person) => person.id === selectedId).id
          )}
          onChange={handleChange}
          label="Created By"
          renderValue={(selected) =>
            admin
              .filter((user) => selected.includes(user.id))
              .map((data) => data.firstname + " " + data.lastname)
              .join(",")
          }
        >
          {admin.map((person) => (
            <MenuItem key={person.id} value={person.id}>
              <Checkbox checked={createdBy.includes(person.id)} />
              <ListItemText
                primary={`${person.firstname} ${person.lastname}`}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
